"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const components_1 = require("../../../components");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const styles_1 = __importDefault(require("./styles"));
const ConfirmDeleteSuccessScreen = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    return (react_1.default.createElement(react_native_1.Pressable, { style: {
            flex: 1,
            backgroundColor: "#F7F7F7",
            justifyContent: "space-between",
        }, onPress: react_native_1.Keyboard.dismiss, disabled: helpler_1.isWeb },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, titleStyle: {
                    alignSelf: "center",
                    paddingRight: (0, scale_1.scale)(20),
                }, title: "アカウント削除", styleContainer: {
                    backgroundColor: Colors_1.default.white,
                } }),
            react_1.default.createElement(react_native_1.KeyboardAvoidingView, null,
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.main },
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.Rectangle }),
                        react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                fontSize: (0, scale_1.moderateScale)(16),
                                lineHeight: (0, scale_1.moderateScale)(24),
                                color: "#292A33",
                                paddingLeft: (0, scale_1.scale)(8),
                            } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664\u5B8C\u4E86")),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                            marginTop: 12,
                        } }, "\u6295\u8CC7\u306E\u5148\u8F29\u3092\u3054\u5229\u7528\u3044\u305F\u3060\u304D\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\u3002"),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                        } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664\u5B8C\u4E86\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F\u306E\u3067\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                        } }),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                        } },
                        '\n',
                        "\u307E\u305F\u306E\u3054\u5229\u7528\u304A\u5F85\u3061\u3057\u3066\u304A\u308A\u307E\u3059\u3002"),
                    react_1.default.createElement(components_1.BorderButton, { title: "\u30DB\u30FC\u30E0\u753B\u9762\u3078", style: {
                            width: '100%',
                            height: (0, scale_1.scale)(48),
                            marginTop: (0, scale_1.scale)(32),
                        }, textStyle: {
                            fontSize: (0, scale_1.moderateScale)(16),
                            lineHeight: (0, scale_1.moderateScale)(24),
                            color: '#1960B0'
                        }, onPress: () => {
                            dispatch(slice_1.default.actions.logout());
                            (0, rootNavigation_1.reset)({ index: 0, routeName: Routes_1.default.MAINTABBAR });
                        } }))))));
};
exports.default = ConfirmDeleteSuccessScreen;
